import { useLang } from "../i18n";
import { colors, fontHeading } from "../theme";
import { SITE } from "../siteConfig";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer style={s.footer}>
      <div style={s.inner}>
        <img src="/images/logo.png" alt={SITE.name} width={332} height={104} style={s.logoImg} />
        <p style={s.text}>{SITE.address}</p>
        <p style={s.text}>
          <a href={`tel:${SITE.phone.replace(/\s+/g, "")}`} style={s.link} className="link-hover">
            {SITE.phone}
          </a>
        </p>
        <div style={s.divider} />
        <p style={s.small} suppressHydrationWarning>
          © {new Date().getFullYear()} {SITE.name}. {t.footerRights}
        </p>
        <p style={s.small}>{t.footerTagline}</p>
      </div>
    </footer>
  );
}

const s = {
  footer: { background: colors.bgAlt, borderTop: `1px solid ${colors.border}`, padding: "48px 40px" },
  inner: { maxWidth: 1280, margin: "0 auto", display: "flex", flexDirection: "column", alignItems: "center", gap: 8 },
  logoImg: { height: 40, width: "auto", marginBottom: 8 },
  text: { fontSize: 14, color: colors.body, margin: 0, fontFamily: fontHeading },
  link: { color: colors.body, textDecoration: "none" },
  divider: { width: 40, height: 1, background: colors.borderStrong, margin: "16px 0" },
  small: { fontSize: 12, color: colors.faint, letterSpacing: "0.04em", margin: 0 },
};
